import { StudentHome } from './StudentHome';

export function StudentDashboard() {
  return <StudentHome />;
}
